const data = [
    {
        date: "Apr 01, 2022",
        header: "Registrations begins and release of Problem statement.",
        text: "Invite your friends, create team, register and start working on your ideas",
    },
    {
        date: "Apr 14, 2022",
        header: "Registration ends",
        text: "Time to pull up your socks and get ready for the grind.",
    },
    {
        date: "Apr 15, 2022",
        header: "Opening ceremony (6:00-6:30 PM)",
        text: "Get Set and Hack!",
    },
    {
        date: "Apr 16, 2022",
        header: "Deadline of submission of your presentation",
        text: "Submit your initial presentation and get the ball rolling.",
    },
    {
        date: "Apr 17, 2022",
        header: "Deadline of submission of your prototypes",
        text: "Breathless 48 hrs of Hackathon come to an end",
    },
    {
        date: "Apr 01, 2022",
        header: "Judging round begins",
        text: "Time to relax, while the judges go through the submissions",
    },
    {
        date: "Apr 01, 2022",
        header: "Closing ceremony and announcement of winners",
        text: "Finally, the wait end! ",
    },

]

export default data;